// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3db946b2","455":"a2f665bb","977":"0dde78dc"}[chunkId] + ".chunk.js";
};